import {white} from 'material-ui/styles/colors';

const styles = {
    list: {display: 'inline-block',
        position: 'relative',
        top: 0,
        color: white
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/OpenExploreModuleBlock/OpenExploreModuleBlock.css.js